import request from './request'

// 登录
export function userLogin(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 刷新token
export function userRefreshToken(data) {
  return request({
    url: '/user/refreshToken',
    method: 'post',
    data
  })
}

// 发送手机验证码
export function userSendCode(data) {
  return request({
    url: '/user/sendCode',
    method: 'post',
    data
  })
}

// 注册
export function userRegister(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

// 用户信息
export function userGetInfo(params) {
  return request({
    url: '/user/info',
    method: 'get',
    params
  })
}

// 找回密码
export function userResetPwd(data) {
  return request({
    url: '/user/resetPassword',
    method: 'post',
    data
  })
}

// 修改手机号
export function userUpdateMobile(data) {
  return request({
    url: '/user/update-mobile',
    method: 'post',
    data
  })
}

// 修改密码
export function userChangePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'post',
    data
  })
}

// 修改密码
export function userDeleteAccount(data) {
  return request({
    url: '/user/delete-account',
    method: 'post',
    data
  })
}

// 充值套餐
export function paymentGetProduct(params) {
  return request({
    url: '/payment/product',
    method: 'get',
    params
  })
}

// 充值消费明细
export function paymentGetBeans(type, params) {
  return request({
    url: '/user/beans_list/' + type,
    method: 'get',
    params
  })
}

// 充值url
export function paymentGetProductUrl(params) {
  return request({
    url: '/payment//url',
    method: 'get',
    params
  })
}

// 充值结果
export function paymentGetProductStatus(params) {
  return request({
    url: '/payment/queryStatus',
    method: 'get',
    params
  })
}
